// extracted by mini-css-extract-plugin
module.exports = {"summary":"OrderSummary_summary_2X5BW"};